import { createContext } from 'react';

const ReactIdContext = createContext<string>('');
ReactIdContext.displayName = 'ReactIDContext';

export default ReactIdContext;
